import { Empty, Row, Spin } from 'antd';
import { AxiosResponse } from 'axios';
import aptApis from 'features/Booking/services/apis';
import moment, { Moment } from 'moment';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import styled from 'styled-components';
import { ITimelineItem } from 'utils/getTimeLines';
import { bookingSignal } from '../signal';
import disabled_time from './disabled-time.png';
import { last } from 'lodash';
type Ref = {
  fetchTimes: (date: Moment | null) => void;
};
export const bookingTimeSlotListRef = React.createRef<Ref>();
type Props = {
  onChooseTimeSlot: (time: string) => void;
};
const BookingTimeSlotList = forwardRef<Ref, Props>(({ onChooseTimeSlot }, ref) => {
  const [rowTimesMaster, setRowTimesMaster] = useState<ITimelineItem[]>([]);
  // const scheduleBooking = shopSelectors.scheduleBooking();
  const [loading, setLoading] = useState(false);

  const fetchTimes = async (date: Moment | null) => {
    if (!date) return;
    setLoading(true);
    try {
      const res: AxiosResponse<{ payload: string[] }> = await aptApis.getAvailableTimeSlotByStore(date.format('MM-DD-YYYY'));
      if (res.data.payload) {
        const result = res.data.payload.map(o => {
          const time = moment(date.format('MM-DD-YYYY') + ' ' + o, 'MM-DD-YYYY HH:mm');
          return ({
            id: time.format('hh:mm A'),
            value: time,
            disabled: false,
          });
        });
        bookingSignal.lastestTimeSlots.value = last(result) || null;
        setRowTimesMaster(result);
      } else {
        setRowTimesMaster([]);
      }
    } catch (error) {
      setRowTimesMaster([]);
    } finally {
      setLoading(false);
    }
  };

  // const rowTimesMaster = useMemo(() => {
  //   const date = bookingSignal.date.value || moment();
  //   const schema = convertSalonWorkingTime(date.format('ddd') || '', scheduleBooking);
  //   return getTimeLines(setTimeByDdd(date, schema.timeHourStart, schema.timeMinuteStart), setTimeByDdd(date, schema.timeHourEnd, schema.timeMinuteEnd), 15);
  // }, [bookingSignal.date.value, scheduleBooking]);

  const handleChooseTimeSlot = (o: string) => () => {
    onChooseTimeSlot(o);
  };

  useImperativeHandle(ref, () => ({
    fetchTimes: (date) => fetchTimes(date),
  }));

  return (
    <Container>
      <div className="label-section">Select time</div>
      {!rowTimesMaster.length ? <Row justify={'center'}> <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} /></Row> : null}
      {!!loading && <Spin spinning />}
      <TimeSlotsContainer className='TimeSlotsContainer'>
        {rowTimesMaster.map(o => (
          <button
            key={o.id}
            type='button'
            onClick={handleChooseTimeSlot(o.id)}
            className={`btn btn-time-slot ${bookingSignal.time.value === o.id ? 'active' : ''} ${o.disabled ? 'disabled' : ''}`}>
            <span>{o.id}</span>
            {o.disabled && <img src={disabled_time} alt="disabled" className='disabled-time' />}
          </button>
        ))}
      </TimeSlotsContainer>
    </Container>
  );
});
BookingTimeSlotList.displayName = 'BookingTimeSlotList';
export default BookingTimeSlotList;

const TimeSlotsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 8px;
  .btn.btn-time-slot {
    display: flex;
    padding: 12px 4px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex: 1 0 0;
    align-self: stretch;
    border-radius: 5px;
    border: 1px solid #C9CDD4;
    background: #fff;
    span {
      color: #1D2129;
      text-align: center;
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }

    &.active {
      border: 1px solid #1A7EC8;
      background: #DCF0FF;
      span {
        font-weight: 500;
      }
    }
    .disabled-time {
      display: none;
    }
    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
      position: relative;
      .disabled-time {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
`;

const Container = styled.div`
  .label-section {
    color: #1D2129;
    text-align: left;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.54px;
    margin-bottom: 8px;
  }

  @media (min-width:600px)  {
    .label-section {
      font-size: 18px;
    }
    .TimeSlotsContainer {
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-gap: 16px;
       .btn.btn-time-slot {
          span {
            font-size: 18px;
          }
       }
    }
  }
`;